import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './donationLocales/en.json';
import nl from './donationLocales/nl.json';
import gr from './donationLocales/gr.json';
import fr from './donationLocales/fr.json';
import it from './donationLocales/it.json';

export const languageResources = {
  en: { translation: en },
  nl: { translation: nl },
  gr: { translation: gr },
  fr: { translation: fr },
  it: { translation: it },
};

i18next.use(initReactI18next).init({
  compatibilityJSON: 'v3',
  lng: 'nl',
  debug:false,
  fallbackLng: 'en',
  resources: languageResources,
  backend: {
    loadPath: './donationLocales' // Update this path
  }
});

i18next.on('languageChanged', (lng) => {
  console.log('donation Language changed to', lng);
});

i18next.on('missingKey', (lng, ns, key) => {
  console.log(`Missing key ${key} in ${lng}/${ns}`);
});

export default i18next;
